import dayjs from 'dayjs';
import { formatPhoneNumber } from '@frontend/phone-numbers';
import { InlineNotification, SpinningLoader, Text } from '@frontend/design-system';
import type { TrueLarkBusinessDetails } from '../index';
import { truelarkStyles as styles } from '../styles';

type FieldRowProps = { label: string; value: string | undefined };

function FieldRow({ label, value }: FieldRowProps) {
  return (
    <div css={styles.detailsFieldRow}>
      <Text size='small' color='subdued'>
        {label}
      </Text>
      <Text size='medium'>{value ?? '—'}</Text>
    </div>
  );
}

type Props = { data: TrueLarkBusinessDetails | undefined; isLoading: boolean; isError: boolean };

export function BusinessDetailsCard({ data, isLoading, isError }: Props) {
  if (isLoading) return <SpinningLoader size='small' />;
  if (isError) return <InlineNotification status='error' message='Failed to load business details' />;
  if (!data) return <Text color='subdued'>No details available</Text>;

  return (
    <div css={styles.detailsFieldsGrid}>
      <FieldRow label='Name' value={data.businessName} />
      <FieldRow label='Weave Phone' value={data.assignedPhone ? formatPhoneNumber(data.assignedPhone) : undefined} />
      <FieldRow label='Weave Location ID' value={data.weaveLocationId} />
      <FieldRow label='Booking Software' value={data.associatedPms} />
      <FieldRow label='PMS Name' value={data.kind} />
      <FieldRow label='PMS Location ID' value={data.pmsNameAndId?.id} />
      <FieldRow
        label='Last Sync Time'
        value={data.lastSyncTime ? dayjs(data.lastSyncTime).format('dddd, MMMM D, YYYY [at] h:mm A') : undefined}
      />
    </div>
  );
}
